export { publicAssetLabel } from "./asset.js";
/** The most visits one link shows; past it, `truncated` says there are more. */
export const ASSET_SHARE_MAX_VISITS = 50;
/**
 * The label inside a sentence: «tu aire acondicionado Samsung AR12». Its first
 * two parts, the name and the make and model, read as words without the
 * separators; the colour stays on the page. Only the name's first letter drops
 * its capital: make and model stay as written.
 */
export function assetInSentence(assetLabel) {
    const words = assetLabel.split(" · ").slice(0, 2).join(" ");
    return words.charAt(0).toLowerCase() + words.slice(1);
}
/** What the customer's chat opens with when they write to the workshop from the page. */
export function assetContactMessage(assetLabel) {
    return `Hola, te escribo por mi ${assetInSentence(assetLabel)}`;
}
